if (document.querySelector(".section-sticky-atc")) {
  const showAtcSticky = () => {
    const atcSticky = document.querySelector(".section-sticky-atc");
    const atcButton = document.querySelector(".product__add-to-cart");
    let isButtonScrolled = false;

    const handleScroll = () => {
      const buttonRect = atcButton.getBoundingClientRect();
      const scrollPosition = window.scrollY || window.pageYOffset;

      if (scrollPosition > buttonRect.bottom) {
        isButtonScrolled = true;
        atcSticky.classList.add("sticky-visible");
      } else if (isButtonScrolled && scrollPosition <= buttonRect.bottom) {
        isButtonScrolled = false;
        atcSticky.classList.remove("sticky-visible");
      }
    };

    window.addEventListener("scroll", handleScroll);
  };
  
  showAtcSticky();
  document.addEventListener("shopify:section:load", showAtcSticky);
  document.addEventListener("shopify:section:unload", showAtcSticky);
}
